import React from 'react'
import PropTypes from 'prop-types'
import {Box, Button, useStyleConfig} from '@salesforce/retail-react-app/app/components/shared/ui'
import useTagManager from '../../../hooks/use-tag-manager'
import {scheduleIdleAnalytics} from '../../../utils/common-utils'

export const hasProductReviews = (product) => {
    const reviewCount = Number(product?.c_bvReviewCount)

    return Number.isFinite(reviewCount) && reviewCount >= 1
}

export const shouldPromoteProductRating = (product) => {
    const averageRating = Number(product?.c_bvAverageRating)
    const reviewCount = Number(product?.c_bvReviewCount)

    return (
        Number.isFinite(averageRating) &&
        Number.isFinite(reviewCount) &&
        averageRating >= 4 &&
        reviewCount >= 3
    )
}

export const shouldShowPromotedProductRating = (
    product,
    {isCart = false, isEngagementProduct = false} = {}
) => !isCart && !isEngagementProduct && !product?.type?.set && shouldPromoteProductRating(product)

export const ProductRatingSummary = ({product, placement = 'reviews'}) => {
    return (
        <Box
            className="pdp-rating"
            data-bv-show="rating_summary"
            data-bv-product-id={product?.id}
            data-use-variant-id={true}
            id="data-bv-show"
            display="inline-block"
            marginLeft={placement === 'reviews' ? 4 : 0}
        />
    )
}

export const handleProductReviewsClick = (event, product, tagManager) => {
    event.preventDefault()
    event.stopPropagation()
    scheduleIdleAnalytics(() => tagManager.reviewsClick(product?.name))

    const container = document.getElementById('bv-product-reviews')
    if (container) {
        const scrollToReviews = () => {
            const top = container.getBoundingClientRect().top + window.scrollY - 100
            window.scrollTo({top, behavior: 'smooth'})
        }

        scrollToReviews()
        window.setTimeout(scrollToReviews, 300)
    }
}

const ProductRating = ({product, placement = 'reviews'}) => {
    const tagManager = useTagManager()
    const styles = useStyleConfig('ProductRating')

    if (!hasProductReviews(product)) return null

    return (
        <Button
            id="pdp-rating-summary"
            data-monetate-id="pdp-rating-summary"
            data-rating-placement={placement}
            onClick={(event) => handleProductReviewsClick(event, product, tagManager)}
            variant="unstyled"
            position="relative"
            display="inline-flex"
            minHeight="unset"
            height="auto"
            padding="0"
            alignItems="center"
            sx={styles.trigger}
            _after={{
                content: '""',
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
            }}
        >
            <ProductRatingSummary product={product} placement={placement} />
        </Button>
    )
}

ProductRatingSummary.propTypes = {
    product: PropTypes.object.isRequired,
    placement: PropTypes.oneOf(['title', 'reviews'])
}

ProductRating.propTypes = {
    product: PropTypes.object.isRequired,
    placement: PropTypes.oneOf(['title', 'reviews'])
}

export default ProductRating
